var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _vm.view === "new"
        ? [
            _c(
              "div",
              {
                staticClass: "d-flex align-center mb-2"
              },
              [
                _c(
                  "gg-btn",
                  {
                    staticClass: "kvm-dk-text ml-n2",
                    attrs: {
                      small: "",
                      text: ""
                    },
                    on: {
                      click: _vm.back
                    }
                  },
                  [
                    _c(
                      "v-icon",
                      {
                        attrs: {
                          left: "",
                          small: "",
                          "aria-hidden": "true"
                        }
                      },
                      [_vm._v("mdi-arrow-left")]
                    ),
                    _vm._v(_vm._s(_vm.backLabel) + " ")
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "h3",
              {
                staticClass: "body-1 font-weight-medium mb-1"
              },
              [_vm._v("Deploy a new app")]
            ),
            _c("kvm-docker-templates", {
              attrs: {
                "service-id": _vm.serviceId,
                "refresh-key": _vm.refreshKey
              },
              on: {
                operation: function operation($event) {
                  return _vm.$emit("operation", $event)
                },
                done: _vm.back,
                custom: _vm.openNew
              }
            })
          ]
        : _vm.view === "manage" && _vm.managedStack
        ? _c("kvm-docker-app-manage", {
            attrs: {
              "service-id": _vm.serviceId,
              stack: _vm.managedStack,
              "busy-label": _vm.busy[_vm.managedStack.name]
                ? _vm.busy[_vm.managedStack.name].label
                : "",
              "refresh-key": _vm.refreshKey
            },
            on: {
              back: _vm.back,
              action: function action($event) {
                return _vm.action(_vm.managedStack, $event)
              },
              edit: function edit($event) {
                return _vm.openEdit(_vm.managedStack)
              },
              remove: function remove($event) {
                return _vm.confirmRemove(_vm.managedStack)
              }
            }
          })
        : _vm.view === "manage" && _vm.loading
        ? _c(
            "div",
            {
              staticClass: "py-6 text-center",
              attrs: {
                role: "status"
              }
            },
            [
              _c("v-progress-circular", {
                attrs: {
                  indeterminate: "",
                  color: "primary",
                  size: "32",
                  width: "3"
                }
              }),
              _c(
                "span",
                {
                  staticClass: "kvm-sr-only"
                },
                [_vm._v("Loading the app…")]
              )
            ],
            1
          )
        : [
            _c(
              "div",
              {
                staticClass: "d-flex flex-wrap align-center mb-3"
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "kvm-help text-caption mr-auto"
                  },
                  [_vm._v("The apps installed on this server.")]
                ),
                _c(
                  "gg-btn",
                  {
                    staticClass: "mr-2 mb-1",
                    attrs: {
                      small: "",
                      tile: "",
                      outlined: "",
                      color: "primary",
                      loading: _vm.loading
                    },
                    on: {
                      click: _vm.load
                    }
                  },
                  [
                    _c(
                      "v-icon",
                      {
                        attrs: {
                          left: "",
                          small: "",
                          "aria-hidden": "true"
                        }
                      },
                      [_vm._v("mdi-refresh")]
                    ),
                    _vm._v("Refresh ")
                  ],
                  1
                ),
                _c(
                  "gg-btn",
                  {
                    staticClass: "mb-1 kvm-dk-primary",
                    attrs: {
                      small: "",
                      tile: "",
                      color: "primary"
                    },
                    on: {
                      click: function click($event) {
                        _vm.view = "new"
                      }
                    }
                  },
                  [
                    _c(
                      "v-icon",
                      {
                        attrs: {
                          left: "",
                          small: "",
                          "aria-hidden": "true"
                        }
                      },
                      [_vm._v("mdi-plus")]
                    ),
                    _vm._v("Deploy new app ")
                  ],
                  1
                )
              ],
              1
            ),
            _vm.error
              ? _c(
                  "v-alert",
                  {
                    attrs: {
                      type: "error",
                      border: "left",
                      dense: "",
                      role: "alert"
                    }
                  },
                  [_vm._v(_vm._s(_vm.error))]
                )
              : _vm._e(),
            _vm.loading && !_vm.loaded
              ? _c(
                  "div",
                  {
                    staticClass: "py-6 text-center",
                    attrs: {
                      role: "status"
                    }
                  },
                  [
                    _c("v-progress-circular", {
                      attrs: {
                        indeterminate: "",
                        color: "primary",
                        size: "32",
                        width: "3"
                      }
                    }),
                    _c(
                      "span",
                      {
                        staticClass: "kvm-sr-only"
                      },
                      [_vm._v("Loading apps…")]
                    )
                  ],
                  1
                )
              : _vm.loaded && !_vm.stacks.length
              ? _c(
                  "div",
                  {
                    staticClass: "my-6 text-center"
                  },
                  [
                    _c(
                      "p",
                      {
                        staticClass: "kvm-help mb-3"
                      },
                      [_vm._v("No apps yet.")]
                    ),
                    _c(
                      "gg-btn",
                      {
                        staticClass: "kvm-dk-primary",
                        attrs: {
                          tile: "",
                          color: "primary"
                        },
                        on: {
                          click: function click($event) {
                            _vm.view = "new"
                          }
                        }
                      },
                      [
                        _c(
                          "v-icon",
                          {
                            attrs: {
                              left: "",
                              small: "",
                              "aria-hidden": "true"
                            }
                          },
                          [_vm._v("mdi-plus")]
                        ),
                        _vm._v("Deploy your first app ")
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm.stacks.length
              ? _c(
                  "v-simple-table",
                  {
                    staticClass: "kvm-dk-table",
                    attrs: {
                      dense: ""
                    }
                  },
                  [
                    _c(
                      "caption",
                      {
                        staticClass: "kvm-sr-only"
                      },
                      [_vm._v("Apps")]
                    ),
                    _c("thead", [
                      _c("tr", [
                        _c(
                          "th",
                          {
                            attrs: {
                              scope: "col"
                            }
                          },
                          [_vm._v("Name")]
                        ),
                        _c(
                          "th",
                          {
                            attrs: {
                              scope: "col"
                            }
                          },
                          [_vm._v("Status")]
                        ),
                        _c(
                          "th",
                          {
                            staticClass: "text-right",
                            attrs: {
                              scope: "col"
                            }
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "kvm-sr-only"
                              },
                              [_vm._v("Actions")]
                            )
                          ]
                        )
                      ])
                    ]),
                    _c(
                      "tbody",
                      _vm._l(_vm.stacks, function(s) {
                        return _c(
                          "tr",
                          {
                            key: s.name,
                            class: {
                              "kvm-dk-row--busy": _vm.busy[s.name]
                            },
                            attrs: {
                              "aria-busy": _vm.busy[s.name] ? "true" : "false"
                            }
                          },
                          [
                            _c(
                              "td",
                              {
                                attrs: {
                                  "data-label": "Name"
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "font-weight-medium"
                                  },
                                  [_vm._v(_vm._s(s.name))]
                                ),
                                s.system
                                  ? _c(
                                      "v-chip",
                                      {
                                        staticClass: "ml-2",
                                        attrs: {
                                          "x-small": "",
                                          label: "",
                                          title:
                                            "Runs your domains — managed from the Domains tab"
                                        }
                                      },
                                      [_vm._v("domains")]
                                    )
                                  : !s.managed
                                  ? _c(
                                      "v-chip",
                                      {
                                        staticClass: "ml-2",
                                        attrs: {
                                          "x-small": "",
                                          label: "",
                                          title:
                                            "Created outside this panel — view only"
                                        }
                                      },
                                      [_vm._v("external")]
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _c(
                              "td",
                              {
                                attrs: {
                                  "data-label": "Status"
                                }
                              },
                              [
                                _vm.busy[s.name]
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "kvm-dk-busy",
                                        attrs: {
                                          role: "status"
                                        }
                                      },
                                      [
                                        _c("v-progress-circular", {
                                          staticClass: "mr-1",
                                          attrs: {
                                            indeterminate: "",
                                            size: "14",
                                            width: "2",
                                            color: "primary",
                                            "aria-hidden": "true"
                                          }
                                        }),
                                        _vm._v(
                                          _vm._s(_vm.busy[s.name].label) + " "
                                        )
                                      ],
                                      1
                                    )
                                  : [_vm._v(_vm._s(s.status))]
                              ],
                              2
                            ),
                            _c(
                              "td",
                              {
                                staticClass: "text-right text-no-wrap",
                                attrs: {
                                  "data-label": "Actions"
                                }
                              },
                              [
                                !s.system
                                  ? _c(
                                      "gg-btn",
                                      {
                                        staticClass: "mr-1",
                                        attrs: {
                                          small: "",
                                          tile: "",
                                          outlined: "",
                                          color: "primary",
                                          disabled: !!_vm.busy[s.name]
                                        },
                                        on: {
                                          click: function click($event) {
                                            return _vm.openManage(s)
                                          }
                                        }
                                      },
                                      [_vm._v("Manage")]
                                    )
                                  : _vm._e(),
                                _c(
                                  "v-menu",
                                  {
                                    attrs: {
                                      "offset-y": "",
                                      left: ""
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function fn(_ref) {
                                            var on = _ref.on,
                                              attrs = _ref.attrs
                                            return [
                                              _c(
                                                "gg-btn",
                                                _vm._g(
                                                  _vm._b(
                                                    {
                                                      attrs: {
                                                        icon: "",
                                                        small: "",
                                                        "aria-label":
                                                          "Actions for " +
                                                          s.name,
                                                        disabled: !!_vm.busy[
                                                          s.name
                                                        ]
                                                      }
                                                    },
                                                    "gg-btn",
                                                    attrs,
                                                    false
                                                  ),
                                                  on
                                                ),
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        small: ""
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "mdi-dots-vertical"
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  },
                                  [
                                    _c(
                                      "v-list",
                                      {
                                        attrs: {
                                          dense: ""
                                        }
                                      },
                                      [
                                        !s.system
                                          ? _c(
                                              "v-list-item",
                                              {
                                                on: {
                                                  click: function click(
                                                    $event
                                                  ) {
                                                    return _vm.openEdit(s)
                                                  }
                                                }
                                              },
                                              [
                                                _c("v-list-item-title", [
                                                  _vm._v(
                                                    _vm._s(
                                                      s.managed
                                                        ? "Edit compose file"
                                                        : "View details"
                                                    )
                                                  )
                                                ])
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        s.managed && !s.system
                                          ? _c(
                                              "v-list-item",
                                              {
                                                on: {
                                                  click: function click(
                                                    $event
                                                  ) {
                                                    return _vm.action(s, "up")
                                                  }
                                                }
                                              },
                                              [
                                                _c("v-list-item-title", [
                                                  _vm._v("Redeploy")
                                                ])
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        s.managed && !s.system
                                          ? _c(
                                              "v-list-item",
                                              {
                                                on: {
                                                  click: function click(
                                                    $event
                                                  ) {
                                                    return _vm.action(
                                                      s,
                                                      "update"
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("v-list-item-title", [
                                                  _vm._v(
                                                    "Update to the newest build"
                                                  )
                                                ])
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _c(
                                          "v-list-item",
                                          {
                                            on: {
                                              click: function click($event) {
                                                return _vm.action(s, "restart")
                                              }
                                            }
                                          },
                                          [
                                            _c("v-list-item-title", [
                                              _vm._v("Restart")
                                            ])
                                          ],
                                          1
                                        ),
                                        !s.system
                                          ? _c(
                                              "v-list-item",
                                              {
                                                on: {
                                                  click: function click(
                                                    $event
                                                  ) {
                                                    return _vm.action(s, "stop")
                                                  }
                                                }
                                              },
                                              [
                                                _c("v-list-item-title", [
                                                  _vm._v("Stop")
                                                ])
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _c(
                                          "v-list-item",
                                          {
                                            on: {
                                              click: function click($event) {
                                                return _vm.action(s, "start")
                                              }
                                            }
                                          },
                                          [
                                            _c("v-list-item-title", [
                                              _vm._v("Start")
                                            ])
                                          ],
                                          1
                                        ),
                                        !s.system
                                          ? _c(
                                              "v-list-item",
                                              {
                                                on: {
                                                  click: function click(
                                                    $event
                                                  ) {
                                                    return _vm.action(s, "down")
                                                  }
                                                }
                                              },
                                              [
                                                _c("v-list-item-title", [
                                                  _vm._v(
                                                    "Take down (remove containers)"
                                                  )
                                                ])
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        s.managed && !s.system
                                          ? _c(
                                              "v-list-item",
                                              {
                                                on: {
                                                  click: function click(
                                                    $event
                                                  ) {
                                                    return _vm.confirmRemove(s)
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-list-item-title",
                                                  {
                                                    staticClass: "error--text"
                                                  },
                                                  [_vm._v("Delete app…")]
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ]
                )
              : _vm._e()
          ],
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "900",
            persistent: ""
          },
          model: {
            value: _vm.editor.open,
            callback: function callback($$v) {
              _vm.$set(_vm.editor, "open", $$v)
            },
            expression: "editor.open"
          }
        },
        [
          _c(
            "gg-card",
            {
              attrs: {
                role: "dialog",
                "aria-modal": "true",
                "aria-labelledby": "kvm-dk-stack-title"
              }
            },
            [
              _c(
                "gg-card-text",
                {
                  staticClass: "pa-4"
                },
                [
                  _c(
                    "h3",
                    {
                      staticClass: "body-1 font-weight-medium mb-3",
                      attrs: {
                        id: "kvm-dk-stack-title"
                      }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.editor.isNew
                              ? "Custom app"
                              : _vm.editor.readonly
                              ? "App"
                              : "Edit app"
                          ) +
                          _vm._s(
                            _vm.editor.isNew
                              ? ""
                              : " \u2014 ".concat(_vm.editor.name)
                          ) +
                          " "
                      )
                    ]
                  ),
                  _vm.editor.loading
                    ? _c(
                        "div",
                        {
                          staticClass: "py-6 text-center"
                        },
                        [
                          _c("v-progress-circular", {
                            attrs: {
                              indeterminate: "",
                              color: "primary"
                            }
                          })
                        ],
                        1
                      )
                    : [
                        _vm.editor.isNew
                          ? _c("v-text-field", {
                              staticClass: "mb-3",
                              attrs: {
                                label: "App name",
                                outlined: "",
                                dense: "",
                                hint:
                                  "Lowercase letters, numbers, - and _ (e.g. my-app)",
                                "persistent-hint": ""
                              },
                              model: {
                                value: _vm.editor.name,
                                callback: function callback($$v) {
                                  _vm.$set(
                                    _vm.editor,
                                    "name",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "editor.name"
                              }
                            })
                          : _vm._e(),
                        _vm.editor.readonly
                          ? _c(
                              "v-alert",
                              {
                                staticClass: "mb-3",
                                attrs: {
                                  type: "info",
                                  dense: "",
                                  text: ""
                                }
                              },
                              [
                                _vm._v(
                                  " This app was created outside this panel, so its compose file isn't editable here. You can still restart, stop, start or take it down. "
                                )
                              ]
                            )
                          : _vm._e(),
                        !_vm.editor.readonly
                          ? _c("v-textarea", {
                              staticClass: "kvm-dk-code",
                              attrs: {
                                label: "docker-compose.yml",
                                outlined: "",
                                rows: "16",
                                spellcheck: "false",
                                autocomplete: "off",
                                placeholder: _vm.composePlaceholder
                              },
                              model: {
                                value: _vm.editor.compose,
                                callback: function callback($$v) {
                                  _vm.$set(_vm.editor, "compose", $$v)
                                },
                                expression: "editor.compose"
                              }
                            })
                          : _vm._e(),
                        _vm.editor.containers.length
                          ? [
                              _c(
                                "div",
                                {
                                  staticClass: "subtitle-2 mb-1"
                                },
                                [_vm._v("Containers")]
                              ),
                              _c(
                                "v-simple-table",
                                {
                                  staticClass: "mb-2",
                                  attrs: {
                                    dense: ""
                                  }
                                },
                                [
                                  _c(
                                    "tbody",
                                    _vm._l(_vm.editor.containers, function(c) {
                                      return _c(
                                        "tr",
                                        {
                                          key: c.name
                                        },
                                        [
                                          _c(
                                            "td",
                                            {
                                              staticClass: "font-weight-medium"
                                            },
                                            [_vm._v(_vm._s(c.service))]
                                          ),
                                          _c(
                                            "td",
                                            {
                                              staticClass: "kvm-dk-mono"
                                            },
                                            [_vm._v(_vm._s(c.image))]
                                          ),
                                          _c("td", [_vm._v(_vm._s(c.status))]),
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "kvm-dk-mono text-caption"
                                            },
                                            [_vm._v(_vm._s(c.ports || "—"))]
                                          )
                                        ]
                                      )
                                    }),
                                    0
                                  )
                                ]
                              )
                            ]
                          : _vm._e(),
                        _vm.editor.error
                          ? _c(
                              "v-alert",
                              {
                                staticClass: "mb-0",
                                staticStyle: {
                                  "white-space": "pre-wrap"
                                },
                                attrs: {
                                  type: "warning",
                                  dense: "",
                                  text: "",
                                  role: "alert"
                                }
                              },
                              [_vm._v(_vm._s(_vm.editor.error))]
                            )
                          : _vm._e()
                      ],
                  _c(
                    "div",
                    {
                      staticClass: "text-right mt-3"
                    },
                    [
                      _c(
                        "gg-btn",
                        {
                          staticClass: "mr-2",
                          attrs: {
                            text: "",
                            disabled: _vm.editor.saving
                          },
                          on: {
                            click: function click($event) {
                              _vm.editor.open = false
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.editor.readonly ? "Close" : "Cancel")
                          )
                        ]
                      ),
                      !_vm.editor.readonly
                        ? _c(
                            "gg-btn",
                            {
                              staticClass: "kvm-dk-primary",
                              attrs: {
                                tile: "",
                                color: "primary",
                                loading: _vm.editor.saving,
                                disabled:
                                  !_vm.editor.name || !_vm.editor.compose.trim()
                              },
                              on: {
                                click: _vm.save
                              }
                            },
                            [_vm._v(" Save & deploy ")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "460"
          },
          model: {
            value: _vm.remove.open,
            callback: function callback($$v) {
              _vm.$set(_vm.remove, "open", $$v)
            },
            expression: "remove.open"
          }
        },
        [
          _vm.remove.s
            ? _c(
                "gg-card",
                {
                  attrs: {
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-labelledby": "kvm-dk-srm-title"
                  }
                },
                [
                  _c(
                    "gg-card-text",
                    {
                      staticClass: "pa-4"
                    },
                    [
                      _c(
                        "h3",
                        {
                          staticClass: "body-1 font-weight-medium mb-2",
                          attrs: {
                            id: "kvm-dk-srm-title"
                          }
                        },
                        [
                          _vm._v(
                            "Delete app “" + _vm._s(_vm.remove.s.name) + "”?"
                          )
                        ]
                      ),
                      _vm.remove.loading
                        ? _c(
                            "div",
                            {
                              staticClass: "py-4 text-center",
                              attrs: {
                                role: "status"
                              }
                            },
                            [
                              _c("v-progress-circular", {
                                attrs: {
                                  indeterminate: "",
                                  color: "primary",
                                  size: "24",
                                  width: "2"
                                }
                              }),
                              _c(
                                "span",
                                {
                                  staticClass: "kvm-sr-only"
                                },
                                [_vm._v("Checking what the app contains…")]
                              )
                            ],
                            1
                          )
                        : [
                            _c(
                              "p",
                              {
                                staticClass: "mb-2"
                              },
                              [_vm._v("This removes:")]
                            ),
                            _c(
                              "ul",
                              {
                                staticClass: "kvm-dk-rm mb-3"
                              },
                              [
                                _vm._l(_vm.remove.containers, function(c) {
                                  return _c(
                                    "li",
                                    {
                                      key: c.name
                                    },
                                    [
                                      _vm._v(" Container "),
                                      _c("strong", [
                                        _vm._v(_vm._s(c.service || c.name))
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "kvm-help kvm-dk-mono"
                                        },
                                        [_vm._v(_vm._s(c.image))]
                                      )
                                    ]
                                  )
                                }),
                                _vm._l(_vm.remove.routes, function(r) {
                                  return _c(
                                    "li",
                                    {
                                      key: r.hostname + r.path
                                    },
                                    [
                                      _vm._v(" Domain "),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(r.hostname) +
                                            _vm._s(r.path === "/" ? "" : r.path)
                                        )
                                      ]),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "kvm-help"
                                        },
                                        [
                                          _vm._v(
                                            "— it stops working and is free to use again"
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                }),
                                _c("li", [_vm._v("Its compose file")])
                              ],
                              2
                            ),
                            _vm.remove.routes.length
                              ? _c(
                                  "p",
                                  {
                                    staticClass: "kvm-help text-caption mb-3"
                                  },
                                  [
                                    _vm._v(
                                      " DNS records for your own domains stay as they are — remove them in that domain's DNS if you no longer need them. "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm.remove.volumes_list.length
                              ? [
                                  _c("v-checkbox", {
                                    staticClass: "mt-0",
                                    attrs: {
                                      dense: "",
                                      "hide-details": "",
                                      label: "Also delete its data (".concat(
                                        _vm.remove.volumes_list.length === 1
                                          ? "1 volume"
                                          : _vm.remove.volumes_list.length +
                                              " volumes",
                                        ")"
                                      )
                                    },
                                    model: {
                                      value: _vm.remove.volumes,
                                      callback: function callback($$v) {
                                        _vm.$set(_vm.remove, "volumes", $$v)
                                      },
                                      expression: "remove.volumes"
                                    }
                                  }),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "kvm-help text-caption ml-8 mb-3"
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "kvm-dk-mono"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.remove.volumes_list.join(", ")
                                            )
                                          )
                                        ]
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.remove.volumes
                                              ? "The app's data is permanently erased."
                                              : "Kept — deploying an app with the same name again reuses it."
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ]
                              : _vm._e(),
                            _vm.remove.error
                              ? _c(
                                  "v-alert",
                                  {
                                    staticClass: "mb-3",
                                    attrs: {
                                      type: "warning",
                                      dense: "",
                                      text: ""
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.remove.error))]
                                )
                              : _vm._e()
                          ],
                      _c(
                        "div",
                        {
                          staticClass: "text-right"
                        },
                        [
                          _c(
                            "gg-btn",
                            {
                              staticClass: "mr-2",
                              attrs: {
                                text: ""
                              },
                              on: {
                                click: function click($event) {
                                  _vm.remove.open = false
                                }
                              }
                            },
                            [_vm._v("Cancel")]
                          ),
                          _c(
                            "gg-btn",
                            {
                              attrs: {
                                tile: "",
                                color: "error",
                                disabled: _vm.remove.loading
                              },
                              on: {
                                click: _vm.doRemove
                              }
                            },
                            [_vm._v("Delete")]
                          )
                        ],
                        1
                      )
                    ],
                    2
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }